var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgScanQr(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.54718 6.25V0.625H6.17218V6.25H0.54718ZM1.67218 5.125H5.04718V1.75H1.67218V5.125ZM0.54718 13.375V7.75H6.17218V13.375H0.54718ZM1.67218 12.25H5.04718V8.875H1.67218V12.25ZM7.67218 6.25V0.625H13.2972V6.25H7.67218ZM8.79718 5.125H12.1722V1.75H8.79718V5.125ZM11.8909 13.375V11.9688H13.2972V13.375H11.8909ZM7.67218 9.15625V7.75H9.07843V9.15625H7.67218ZM9.07843 10.5625V9.15625H10.4847V10.5625H9.07843ZM7.67218 11.9688V10.5625H9.07843V11.9688H7.67218ZM9.07843 13.375V11.9688H10.4847V13.375H9.07843ZM10.4847 11.9688V10.5625H11.8909V11.9688H10.4847ZM10.4847 9.15625V7.75H11.8909V9.15625H10.4847ZM11.8909 10.5625V9.15625H13.2972V10.5625H11.8909Z",
    fill: "#3B84E6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScanQr);
export default __webpack_public_path__ + "static/media/scan-qr.4fc5159b6b58b625a7f1118c83fe4d2c.svg";
export { ForwardRef as ReactComponent };